import React from 'react';
import cx from 'classnames';
import * as ICONS from './icons';

import styles from './Icon.module.scss';
import { capitalize } from '../../utils';

export interface IconProps {
  className?: Parameters<typeof cx>[0];
  size?: 14 | 16 | 18 | 20;
  appearance:
    | 'add'
    | 'add-circle'
    | 'activity'
    | 'alert-bell'
    | 'alert-error'
    | 'alert-warning'
    | 'arrow-down'
    | 'arrow-left'
    | 'arrow-right'
    | 'arrow-right-down'
    | 'arrow-up'
    | 'attachment'
    | 'bar-graph'
    | 'book'
    | 'book-open'
    | 'bookmark'
    | 'briefcase'
    | 'build'
    | 'buildings'
    | 'calendar'
    | 'cancel'
    | 'categories'
    | 'checkmark'
    | 'chevron-down'
    | 'chevron-left'
    | 'chevron-left-double'
    | 'chevron-right'
    | 'chevron-right-double'
    | 'chevron-up'
    | 'changelog'
    | 'clipboard'
    | 'close'
    | 'cleared-rec'
    | 'clock'
    | 'comment'
    | 'configure'
    | 'copy'
    | 'database'
    | 'document'
    | 'download'
    | 'docs'
    | 'edit'
    | 'external'
    | 'folder'
    | 'gear'
    | 'globe'
    | 'guide'
    | 'hand'
    | 'hashtag'
    | 'help'
    | 'home'
    | 'identity'
    | 'inbox'
    | 'income'
    | 'incomplete'
    | 'information'
    | 'integrations'
    | 'item-management'
    | 'items'
    | 'key'
    | 'learn'
    | 'libraries'
    | 'lightbulb'
    | 'lightning'
    | 'line-graph'
    | 'link'
    | 'list'
    | 'lock'
    | 'login'
    | 'logout'
    | 'mail'
    | 'menu'
    | 'message'
    | 'mobile'
    | 'new-window'
    | 'notebook'
    | 'overflow'
    | 'overview'
    | 'override'
    | 'pause'
    | 'phone'
    | 'pie-chart'
    | 'platform'
    | 'product-auth'
    | 'product-idv'
    | 'product-monitor'
    | 'product-transactions'
    | 'products'
    | 'progress'
    | 'question'
    | 'refresh'
    | 'rejected-rec'
    | 'remove'
    | 'reset'
    | 'rocket'
    | 'safe'
    | 'sandbox'
    | 'search'
    | 'shield'
    | 'shield-caution'
    | 'sidebar-hide'
    | 'sidebar-show'
    | 'submit'
    | 'subtract'
    | 'switch'
    | 'tag'
    | 'terminal'
    | 'trash'
    | 'transfer'
    | 'tweet'
    | 'unlock'
    | 'user'
    | 'users'
    | 'video'
    | 'wallet'
    | 'webhooks';
  contrast?:
    | 'default'
    | 'low'
    | 'high'
    | 'inverse-default'
    | 'inverse-low'
    | 'inverse-high';
  accessibilityLabel?: string;
}

export const Icon = ({
  className,
  size = 16,
  appearance,
  contrast = 'default',
  accessibilityLabel,
  ...restProps
}: IconProps) => {
  const iconVariant = appearance
    .split('-')
    .map(char => capitalize(char))
    .join('');
  const Component = ICONS[iconVariant + size];

  return (
    <Component
      contrast={contrast}
      accessibilityLabel={accessibilityLabel}
      className={className}
      {...restProps}
    />
  );
};

Icon.displayName = 'Icon';
export default Icon;
export { styles };
